import React, { useEffect, useState } from 'react';
import {
  Switch,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import {
  useSystemSettings,
  useUpdateSystemSettings,
} from './api/getSystemSettings';

const ExperimentalSwitch = () => {
  const { data: systemSetting, refetch } = useSystemSettings({});
  const mutation = useUpdateSystemSettings();

  const [setting, setSetting] = useState(systemSetting?.Detect_Pause);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    refetch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleChange = () => {
    if (systemSetting) {
      const newValue = !setting;
      mutation.mutate(newValue);
      setSetting(newValue);
      if (newValue) {
        setOpen(true);
      }
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (systemSetting) {
      setSetting(systemSetting.Detect_Pause);
    }
  }, [systemSetting]);

  return (
    <Box display='flex' alignItems='center'>
      <Switch checked={setting} onChange={handleChange} />
      <Typography variant='body1'>Pause Reboot Detection</Typography>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{'Experimental Feature Warning'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            This setting is experimental and may cause unexpected behavior. Use
            with caution.
            <br />
            <br />
            This feature enables auto-restart of the server for snapshots in recording mode. If no recordings are detected after 15 minutes with the snapshot enabled, the system will automatically restart. It will then rerun after a 30-minute delay if the problem persists.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
  
};

export default ExperimentalSwitch;
